module.exports = {
    tag: 'speed',
    quality: 0.5,
    speed: 0.5
};